/* 15 Oct (Claude): "Estimated delivery" dates line under Add to Cart on product pages.
   Printed-to-order items 3-5 working days, other products 4-7 (weekends and UK bank holidays skipped).
   It's an estimate, worded as one - no countdowns or fake urgency.
   Undo: remove the delivery-date line in snippets/meta-tags.liquid. */
(function () {
  'use strict';
  /* delivery estimates: printed-to-order 3-5 working days, ready-made accessories 4-7 */
  var P = window.SWW_PDP || {};
  var MADE = /t-?shirt|tee|hoodie|sweatshirt|mug/i.test(P.type || '') || /^(pod|pod-hoodie|mug|personalized)$/i.test(P.tmpl || '');
  var MIN_DAYS = MADE ? 3 : 4, MAX_DAYS = MADE ? 5 : 7;
  /* UK (England & Wales) bank holidays - update this list each year */
  var HOLIDAYS = ['2026-12-25', '2026-12-28', '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-03',
    '2027-05-31', '2027-08-30', '2027-12-27', '2027-12-28', '2028-01-03'];
  function key(d) {
    return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
  }
  function workingDay(d) { var w = d.getDay(); return w !== 0 && w !== 6 && HOLIDAYS.indexOf(key(d)) === -1; }
  function addWorkingDays(start, n) {
    var d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    while (n > 0) { d.setDate(d.getDate() + 1); if (workingDay(d)) n--; }
    return d;
  }
  function fmt(d) {
    try { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); }
    catch (e) { return d.toDateString().slice(0, 10); }
  }
  var TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 6h13v10H1zM14 10h4l3 3v3h-7z"/><circle cx="5.5" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/></svg>';

  function add() {
    if (document.querySelector('.sww-eta')) return;
    var btn = document.querySelector('.product__buy-form .product__buy-button') || document.querySelector('.product__buy-button');
    if (!btn) return;
    var now = new Date();
    var from = addWorkingDays(now, MIN_DAYS), to = addWorkingDays(now, MAX_DAYS);
    var el = document.createElement('p');
    el.className = 'sww-eta';
    el.innerHTML = TRUCK + '<span>Estimated delivery <strong></strong> &ndash; <strong></strong></span>';
    var b = el.querySelectorAll('span strong');
    b[0].textContent = fmt(from);
    b[1].textContent = fmt(to);
    el.setAttribute('title', 'Estimate only - see our delivery details for more.');
    btn.insertAdjacentElement('afterend', el);
  }

  var css = document.createElement('style');
  css.textContent =
    '.sww-eta{flex:0 0 100%;width:100%;display:flex;align-items:center;gap:8px;margin:2px 0 0 !important;padding:0 2px;font-size:14px !important;line-height:1.4 !important;color:#1f4d3a}' +
    '.sww-eta svg{width:20px;height:20px;flex:0 0 20px}' +
    '.sww-eta strong{font-weight:700}' +
    /* keep the line directly under Add to Cart; app boxes (Vitals bundle etc.) follow it */
    '.product__buy-form > *:not(.product__quantity):not(.product__buy-button):not(.sww-eta):not(.vtl-ub-vd-widget){order:2}' +
    /* Vitals "Buy more, save more" box straight after the delivery line, before other app boxes */
    '.product__buy-form > .vtl-ub-vd-widget{order:1}';
  document.head.appendChild(css);

  function run() { try { add(); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
